import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'components/ui';
import { ClickToCopy } from 'components/blocks';
import { key } from 'assets/img';
import './style.css';

class ShowCreatedApiKey extends Component {
  handleRemoveCreatedKey = () => {
    this.props.onRemoveCreatedKey();
  };

  getModalFooter = () => (
    <Button
      className="created-api-key__ok-btn"
      onClick={this.handleRemoveCreatedKey}
    >
      Done
    </Button>
  );

  render() {
    const { createdApiKey } = this.props;

    return (
      <Modal
        className="created-api-key"
        closable={false}
        footer={this.getModalFooter()}
        maskClosable={false}
        visible={!!createdApiKey}
        onOk={this.handleRemoveCreatedKey}
      >
        <img alt="key" src={key} />
        <br />
        <h1> API Key Created</h1>
        <p>
          Please copy this key and save it somewhere safe.
          <br />
          <span className="warn">
            For security reasons, we cannot show it to you again
          </span>
        </p>
        <ClickToCopy value={createdApiKey}>{createdApiKey}</ClickToCopy>
      </Modal>
    );
  }
}

ShowCreatedApiKey.defaultProps = {
  createdApiKey: '',
};

ShowCreatedApiKey.propTypes = {
  createdApiKey: PropTypes.string,
  onRemoveCreatedKey: PropTypes.func.isRequired,
};

export default ShowCreatedApiKey;
